import { render, staticRenderFns } from "./tags.vue?vue&type=template&id=29fc745d&"
import script from "./tags.vue?vue&type=script&lang=js&"
export * from "./tags.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29fc745d')) {
      api.createRecord('29fc745d', component.options)
    } else {
      api.reload('29fc745d', component.options)
    }
    module.hot.accept("./tags.vue?vue&type=template&id=29fc745d&", function () {
      api.rerender('29fc745d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/gantt/columnsConfigBar/components/dropdownOptions/tags.vue"
export default component.exports